/**
 * ShortcutButtonBlock - styles
 */

import styled, { keyframes } from 'styled-components';
import { lighten } from 'polished';
import { H2, P } from 'components/Text/Text.styles';

const svgSlide = keyframes`
	from {
		transform: translateX(0);
	}
	to {
		transform: translateX(4px);
	}
`;

interface LinkProps {
	backgroundColor?: string;
	color?: string;
}

export const StyledH2 = styled(H2)`
	margin: 0 0 1rem 0;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	margin: 3rem 0;
`;

export const Link = styled.a<LinkProps>`
	text-decoration: none;
	border-radius: 999px;
	border: 1px solid ${(props) => props.backgroundColor || '#ffffff'};
	background-color: ${(props) => props.backgroundColor || '#ffffff'};
	color: ${(props) => props.color || '#ffffff'};
	padding: 0.5rem 1rem;
	transition: background-color 0.3s, border-color 0.3s;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.5rem;
	white-space: nowrap;

	&:hover {
		background-color: ${(props) =>
			lighten(0.2, props.backgroundColor || '#ffffff')};
		border-color: ${(props) =>
			lighten(0.2, props.backgroundColor || '#ffffff')};
	}

	svg {
		flex-shrink: 0;
		transition: transform 0.3s ease-in-out;
	}

	&:hover svg {
		animation: ${svgSlide} 0.4s ease-in-out forwards;
	}

	@media (max-width: 768px) {
		max-width: 100%;
	}
`;

export const StyledP = styled(P)`
	margin: 0;
	font-weight: 600;
	font-style: normal;
	font-size: 1rem;
	@media (max-width: 768px) {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;

export const LinksContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
`;
